<template>
  <div class="m-t-10 table-container">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :row-class-name="tableRowClassName">
      <el-table-column
        prop="type"
        label="类型"
        width="150">
      </el-table-column>
      <el-table-column
        label="关联字段">
        <template scope="scope">
          <div v-if="scope.row.x_axis">
            <el-tag class="m-l-10" type="primary">{{ scope.row.x_axis }}</el-tag>
          </div>
          <div v-else-if="scope.row.series">
            <el-tag class="m-l-10" type="primary">{{ scope.row.series }}</el-tag>
          </div>
          <div v-else-if="scope.row.y_axis">
            <el-tag class="m-l-10" type="primary">{{ scope.row.y_axis }}</el-tag>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'barChartTable',
  props: {
    tableData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// barChartTable.vue?74252af4